AppBase.module('Components.PhoneMulticomplete', function (Module, App) {
  'use strict'
  App.reqres.setHandler('phone_multicomplete:view', function (options) {
    return new Module.LayoutView(options || {})
  })
})
